module.exports = __webpack_public_path__ + "static/img/Chelion.15d4949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/Chelion.png
// module id = 5W/8
// module chunks = 34